export enum PostSortBy {
  "NEW" = "new",
  "BEST" = "best",
  "HOT" = "hot",
}
